module.exports = __webpack_public_path__ + "static/img/scripts-samples.dacfb41.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scripts-samples.pdf
// module id = THrl
// module chunks = 0